import { render, staticRenderFns } from "./VerificationOTP.vue?vue&type=template&id=69d58d45&lang=html"
import script from "./VerificationOTP.vue?vue&type=script&lang=js"
export * from "./VerificationOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports